<app-form-field [label]="label" [control]="control" [hint]="hint" [isLoading]="loading" [formSubmitted]="formSubmitted" [success]="valid"
 [forceShowErrorIcon]="showErrorIcon" [applyAlphaNumericOnly]="true" [maxLength]="6">
</app-form-field>

<div class="results">
    <div class="success" *ngIf="results && results!='unspecified'">{{results}}
    </div>
    <div class="error" *ngIf="results && results=='unspecified' && error">{{error}}</div>
</div>